import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { Image as MailBoxImageData } from '../../../store/emailMarketing/emailTemplateEditor';
import { MailBoxProps } from '../types';
import { getColor } from '../../../layout/theme';

const Placeholder = styled.div`
  padding: 14px;
  margin: 28px;
  border: 2px dashed ${props => getColor(props, 'grey')};
`;
export const Image = (props: MailBoxProps<MailBoxImageData>): ReactElement => {
  const { boxData, styles = {}, translations = {} } = props;
  const { src, alt, link } = boxData;

  const { width } = styles;
  const ownStyles = {
    margin: '10px 0',
    maxWidth: width
  };

  let ImgComponent = <img style={ownStyles} src={src} alt={alt || ''} title={alt || ''} />;
  if (link) {
    ImgComponent = <a href={link}>{ImgComponent}</a>;
  }

  // preventing clicks on the anchor when in the editor/preview mode
  const handleAnchorClick = (e: React.MouseEvent<HTMLDivElement>): void => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <div style={styles} onClick={handleAnchorClick}>
      {src && ImgComponent}
      {!src && <Placeholder>{translations.imageEditorPlaceholder}</Placeholder>}
    </div>
  );
};
